/* Rug Branch theme: shared chrome, real Shopify cart (AJAX API), predictive search, helpers.
   Ported from the concept's app.js; the concept's in-memory catalogue is replaced by Shopify data. */
(function () {
  const CFG = window.RBCFG || { routes: {} };
  const R = CFG.routes;
  const LOGO = CFG.logo || '';
  const T = CFG.t || {};
  const tr = (k, fb) => T[k] || fb;

  const icon = {
    close: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M5 5l14 14M19 5 5 19"/></svg>',
  };
  const src = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : u);
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  // Same output as Liquid's | money, using the store's own money format (e.g. "${{amount}}")
  const FR = /^fr/i.test(document.documentElement.getAttribute('lang') || '');
  const money = (cents) => {
    const fmt = CFG.moneyFormat || '${{amount}}';
    const n = Number(cents || 0) / 100;
    const group = (x, d, t, c) => { const [i, f] = x.toFixed(d).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? c + f : ''); };
    if (FR && /^\$\{\{\s*amount\s*\}\}$/.test(fmt.trim())) return group(n, 2, '\u00a0', ',') + '\u00a0$';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: group(n, 2, ',', '.'), amount_no_decimals: group(n, 0, ',', '.'),
      amount_with_comma_separator: group(n, 2, '.', ','), amount_no_decimals_with_comma_separator: group(n, 0, '.', ','),
      amount_with_apostrophe_separator: group(n, 2, "'", '.'),
    }[k] ?? group(n, 2, ',', '.')));
  };
  const $ = (id) => document.getElementById(id);

  // ---------- sizes + rug pad matching ----------
  function dims(v) {
    const t = String(v || '').replace(/[′’]/g, "'").replace(/[″”]/g, '"').replace(/×/g, 'x');
    let m = t.match(/(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?\s*(?:ft)?\s*(?:x\s*\d+(?:\.\d+)?\s*'\s*)?(?:round|rond|redond)/i);
    if (m) { const d = +m[1] + (+m[2] || 0) / 12; return { w: d, h: d, round: true }; }
    m = t.match(/(\d+(?:[.,]\d+)?)\s*m\s*x\s*(\d+(?:[.,]\d+)?)\s*m/i);
    if (m) { const f = (x) => +x.replace(',', '.') / 0.3048; return { w: Math.round(f(m[1]) * 2) / 2, h: Math.round(f(m[2]) * 2) / 2 }; }
    m = t.match(/(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?\s*x\s*(\d+(?:\.\d+)?)\s*'\s*(?:(\d+)\s*"?)?/i);
    if (m) return { w: +m[1] + (+m[2] || 0) / 12, h: +m[3] + (+m[4] || 0) / 12 };
    return null;
  }
  const fmtFt = (d) => { const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h); const f = (x) => { const a = Math.floor(x + 1e-6), i = Math.round((x - a) * 12); return i ? `${a}′${i}″` : `${a}′`; }; return `${f(S)} × ${f(L)}`; };
  // Largest pad size that fits inside the rug (never bigger). Round rugs and pad products get no offer.
  function bestPad(rugSize) {
    const P = CFG.pad; const d = dims(rugSize);
    if (!P || !d || d.round) return null;
    const S = Math.min(d.w, d.h), L = Math.max(d.w, d.h); let best = null;
    P.variants.forEach((v) => {
      const p = dims(v.title); if (!p || p.round || !v.available) return;
      const ps = Math.min(p.w, p.h), pl = Math.max(p.w, p.h);
      if (ps <= S + 1e-6 && pl <= L + 1e-6 && (!best || ps * pl > best.area)) best = { v, area: ps * pl, exact: Math.abs(ps - S) < 0.05 && Math.abs(pl - L) < 0.05, rug: d };
    });
    // only offer a pad that really fits: at most 1 ft shorter than the rug on each side (never a short pad under a long runner)
    if (best) { const bs = Math.min(dims(best.v.title).w, dims(best.v.title).h), bl = Math.max(dims(best.v.title).w, dims(best.v.title).h); if (S - bs > 1.01 || L - bl > 1.01) return null; }
    return best;
  }
  const isPadItem = (i) => CFG.pad && (i.product_id === CFG.pad.id || /pad/i.test(i.product_type || '') || /(^|-)[hm]pad(-|$)/i.test(i.handle || ''));
  // one suggestion per pad size still missing from the bag
  function padSuggestions(cart) {
    if (!CFG.pad) return [];
    const need = new Map();
    cart.items.forEach((i) => {
      if (isPadItem(i)) return;
      const size = (i.variant_options && i.variant_options[0]) || i.variant_title;
      const b = bestPad(size); if (!b) return;
      const cur = need.get(b.v.id) || { b, qty: 0, rugs: [] };
      cur.qty += i.quantity; cur.rugs.push(i); need.set(b.v.id, cur);
    });
    const have = {}; cart.items.forEach((i) => { if (isPadItem(i)) have[i.variant_id] = (have[i.variant_id] || 0) + i.quantity; });
    return [...need.values()].map((n) => ({ ...n, qty: Math.max(0, n.qty - (have[n.b.v.id] || 0)) })).filter((n) => n.qty > 0);
  }
  function padCardHTML(n) {
    const P = CFG.pad, b = n.b, rug = n.rugs[0];
    const forTxt = tr('pad_for', 'for your {size} rug').replace('{size}', fmtFt(b.rug));
    return `<div class="pad-card">
      ${P.image ? `<img src="${esc(P.image)}" alt="" loading="lazy" width="72" height="72">` : ''}
      <div class="pad-txt"><div class="n">${esc(P.title)}</div>
        <div class="s"><span class="pad-size num">${esc(fmtFt(dims(b.v.title)))}</span> ${esc(forTxt)}${n.rugs.length === 1 ? ` · ${esc(String(rug.product_title).split(' ')[0])}` : ''}</div>
        <div class="note">${esc(b.exact ? tr('pad_note_exact', 'Cut to the same size as your rug.') : tr('pad_note_near', 'Sits just inside the edges, and trims easily with scissors should you prefer a closer fit.'))}</div></div>
      <button class="btn ghost pad-btn" type="button" data-pad-add="${b.v.id}" data-pad-qty="${n.qty}">${esc(tr('pad_add', 'Add'))} · <span class="num">${money(b.v.price * n.qty)}</span></button>
    </div>`;
  }
  function padBlockHTML(cart) {
    const list = padSuggestions(cart); if (!list.length) return '';
    return `<div class="pad-up"><div class="eyebrow">${esc(tr('pad_eyebrow', 'Keep it in place'))}</div>${list.map(padCardHTML).join('')}</div>`;
  }
  async function addPad(id, qty) {
    await fetch(cartUrl(R.cartAdd), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] }) });
  }

  // ---------- panels ----------
  let openPanel = null;
  function open(id) {
    close();
    openPanel = $(id); if (!openPanel) return;
    openPanel.classList.add('on'); openPanel.setAttribute('aria-hidden', 'false');
    if (id !== 'mnav') $('scrim').classList.add('on');
    document.body.style.overflow = 'hidden';
    if (id === 'search') setTimeout(() => $('q') && $('q').focus(), 350);
    if (id === 'bag') renderBag();
    if (id === 'wish') renderWish();
  }
  function close() {
    if (!openPanel) return;
    openPanel.classList.remove('on'); openPanel.setAttribute('aria-hidden', 'true');
    $('scrim').classList.remove('on'); document.body.style.overflow = ''; openPanel = null;
  }

  // ---------- wishlist: product handles kept in this browser (no account needed) ----------
  const WKEY = 'rb_wish';
  const HEART = '<svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.2-9.3C1.6 7.3 3.9 4.5 7 4.5c2 0 3.5 1.1 5 3 1.5-1.9 3-3 5-3 3.1 0 5.4 2.8 4.2 6.2C19.5 15.4 12 20 12 20z"/></svg>';
  const wishGet = () => { try { const l = JSON.parse(localStorage.getItem(WKEY) || '[]'); return Array.isArray(l) ? l.filter((h) => typeof h === 'string' && h) : []; } catch (e) { return []; } };
  function wishPaint(root = document) {
    const l = wishGet();
    // Only write when something changed: an unchanged write still counts as a page change, and the page watcher
    // below would repaint again, forever (that loop kept phones busy all the time).
    root.querySelectorAll('[data-wish]').forEach((b) => { const on = l.includes(b.dataset.wish), a = on ? 'true' : 'false'; if (b.classList.contains('on') !== on) b.classList.toggle('on', on); if (b.getAttribute('aria-pressed') !== a) b.setAttribute('aria-pressed', a); });
    document.querySelectorAll('[data-wish-count]').forEach((c) => { const t = String(l.length); if (c.textContent !== t) c.textContent = t; if (c.hidden !== !l.length) c.hidden = !l.length; });
  }
  function wishToggle(btn) {
    const h = btn.dataset.wish; let l = wishGet(); const on = !l.includes(h);
    l = on ? [h, ...l.filter((x) => x !== h)].slice(0, 60) : l.filter((x) => x !== h);
    try { localStorage.setItem(WKEY, JSON.stringify(l)); } catch (e) {}
    wishPaint(); toast(on ? tr('wish_added', 'Saved for later') : tr('wish_removed', 'Removed from saved'));
    if (on) { btn.classList.remove('pop'); void btn.offsetWidth; btn.classList.add('pop'); }
    const inDrawer = btn.closest('#wishBody');
    if (inDrawer && !on) { const card = btn.closest('.card'); if (card) card.remove(); if (!inDrawer.querySelector('.card')) renderWish(); else wishHead(); }
  }
  function wishHead() { const n = wishGet().length, el = $('wishNum'); if (el) el.textContent = tr('wish_count', '{n} saved').replace('{n}', n); }
  async function renderWish() {
    const body = $('wishBody'); if (!body) return;
    const list = wishGet();
    if (!list.length) { body.innerHTML = `<div class="drawer-empty"><span class="wish-empty-ic">${HEART}</span><p>${esc(tr('wish_empty', 'Tap the heart on any rug to keep it here for later.'))}</p><a class="btn ghost" href="${esc(R.all || R.collections || '/collections/all')}">${esc(tr('explore', 'Explore the collection'))}</a></div>`; return; }
    body.innerHTML = `<div class="eyebrow wish-num" id="wishNum"></div><div class="wish-grid" aria-busy="true">${list.map(() => '<div class="wish-ph"></div>').join('')}</div>`; wishHead();
    const base = (R.root || '/').replace(/\/?$/, '/');
    const parts = await Promise.all(list.map((h) => fetch(`${base}products/${encodeURIComponent(h)}?section_id=rb-card-fragment`).then((r) => (r.ok ? r.text() : '')).catch(() => '')));
    const doc = new DOMParser().parseFromString(parts.join(''), 'text/html');
    const grid = body.querySelector('.wish-grid'); if (!grid) return;
    grid.innerHTML = ''; grid.removeAttribute('aria-busy');
    doc.querySelectorAll('.card').forEach((c) => { c.classList.add('in'); grid.appendChild(document.importNode(c, true)); });
    // drop handles whose product no longer exists
    const found = [...grid.querySelectorAll('[data-wish]')].map((b) => b.dataset.wish);
    if (found.length !== list.length) { try { localStorage.setItem(WKEY, JSON.stringify(list.filter((h) => found.includes(h)))); } catch (e) {} }
    wishPaint(); wishHead();
    if (!found.length) renderWish();
  }


  // ---------- cart (Shopify AJAX API) ----------
  const cartUrl = (r) => (r || '').replace(/\/?$/, '') + '.js';
  async function getCart() { const r = await fetch(cartUrl(R.cart), { headers: { Accept: 'application/json' } }); return r.json(); }
  function setCount(n) { const el = $('bagCount'); if (el) el.textContent = n; }
  // properties: line item notes that travel onto the order (e.g. { 'Pre-order': 'Yes' } for the warehouse)
  async function addToBag(variantId, qty, from, properties, extra) {
    try {
      const r = await fetch(cartUrl(R.cartAdd), {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1, ...(properties ? { properties } : {}) }, ...(extra || [])] }),
      });
      const j = await r.json();
      if (!r.ok) { toast(j.description || j.message || tr('add_error', 'Could not add to your bag.')); return false; }
      const cart = await getCart(); setCount(cart.item_count);
      const show = () => open('bag');
      if (from && window.RBMotion) window.RBMotion.fly(from).then(show, show); else show();
      return true;
    } catch (e) { toast(tr('add_error', 'Could not add to your bag. Please try again.')); return false; }
  }
  async function change(key, quantity) {
    await fetch(cartUrl(R.cartChange), {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    renderBag();
  }
  // ---------- discount codes (Cart AJAX API: POST /cart/update.js {discount: "A,B"}; codes carry into checkout) ----------
  let codeMsg = '', codeOpen = false;
  const liveCodes = (cart) => (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
  async function setCodes(list) {
    const r = await fetch(cartUrl(R.cartUpdate || '/cart/update'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: list.join(',') }),
    });
    if (!r.ok) throw new Error('update ' + r.status);
    return r.json();
  }
  async function applyCode(code) {
    code = String(code || '').trim(); codeMsg = '';
    if (!code) return;
    const before = await getCart();
    const keep = liveCodes(before).filter((c) => c.toLowerCase() !== code.toLowerCase());
    let cart = await setCodes(keep.concat(code));
    if (!Array.isArray(cart.discount_codes)) { // older cart API: fall back to the /discount/CODE route
      await fetch((R.root || '/').replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(R.cart || '/cart'), { credentials: 'same-origin' });
      cart = await getCart(); if (!Array.isArray(cart.discount_codes)) return;
    }
    const hit = cart.discount_codes.find((d) => d.code.toLowerCase() === code.toLowerCase());
    if (!hit || !hit.applicable) { // unknown code or not valid for this bag: tell them and keep checkout clean
      // say why: a sale already discounts this bag (codes don't combine with it), or the code itself isn't valid here
      const onSale = (cart.cart_level_discount_applications || []).length || (cart.items || []).some((i) => (i.line_level_discount_allocations || []).some((d) => d.amount > 0));
      codeMsg = onSale
        ? tr('code_combo', FR ? 'Ce code ne peut pas être utilisé : il n’existe pas, ou il ne se combine pas avec les soldes déjà appliqués à votre panier.' : 'This code can’t be used. Either it isn’t valid, or it can’t be combined with the sale already on your bag.')
        : tr('code_bad', FR ? 'Ce code ne s’applique pas aux articles de votre panier. Vérifiez l’orthographe.' : 'This code isn’t valid for the items in your bag. Please check the spelling.');
      codeOpen = true;
      if (hit) await setCodes(liveCodes(cart));
    }
  }
  function codeBoxHTML(cart, idp = 'rbCodeIn') {
    const chips = liveCodes(cart);
    const show = codeOpen || !!codeMsg;
    return `<div class="rb-code">${chips.length ? `<div class="rb-code-chips">${chips.map((c) => `<span class="rb-chip">${esc(c)}<button type="button" data-code-rm="${esc(c)}" aria-label="${esc(tr('code_remove', 'Remove code'))} ${esc(c)}">${icon.close}</button></span>`).join('')}</div>` : ''}
      ${show ? `<form class="rb-code-form" data-code-form novalidate><label class="visually-hidden" for="${idp}">${esc(tr('code_label', 'Discount code'))}</label><input id="${idp}" name="code" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="${esc(tr('code_label', 'Discount code'))}"><button type="submit">${esc(tr('code_apply', 'Apply'))}</button></form>`
        : `<button type="button" class="rb-code-toggle" data-code-open>${esc(tr(chips.length ? 'code_another' : 'code_toggle', chips.length ? 'Add another code' : 'Have a discount code?'))}</button>`}
      ${codeMsg ? `<p class="rb-code-msg" role="alert">${esc(codeMsg)}</p>` : ''}</div>`;
  }
  // wires one code box; after() re-renders (drawer) or reloads (cart page)
  function wireCode(root, after) {
    root.addEventListener('click', async (e) => {
      const o = e.target.closest('[data-code-open]');
      if (o) { codeOpen = true; await after(true); const i = root.querySelector('.rb-code-form input'); if (i) i.focus(); return; }
      const rm = e.target.closest('[data-code-rm]'); if (!rm) return;
      rm.disabled = true; codeMsg = '';
      try { const cart = await getCart(); await setCodes(liveCodes(cart).filter((c) => c !== rm.dataset.codeRm)); } catch (err) { codeMsg = tr('code_error', 'Something went wrong. Please try again.'); }
      after();
    });
    root.addEventListener('submit', async (e) => {
      const fm = e.target.closest('[data-code-form]'); if (!fm) return; e.preventDefault();
      const btn = fm.querySelector('button'); btn.disabled = true; btn.textContent = tr('loading', 'Loading');
      try { await applyCode(fm.code.value); if (!codeMsg) codeOpen = false; } catch (err) { codeMsg = tr('code_error', 'Something went wrong. Please try again.'); }
      after();
    });
  }

  // Final sale (Waise, board q-deals-final-sale): a rug tagged final-sale gets one line in the bag. Cart items carry no
  // tags, so each product's tags are read once from /products/<handle>.js and kept for the visit.
  const fsCache = {};
  async function finalSale(items) {
    const pre = window.RB_FS_PREVIEW || [];
    await Promise.all(items.map(async (i) => {
      if (i.handle in fsCache) return;
      if (pre.includes(i.handle)) { fsCache[i.handle] = true; return; }
      try {
        const p = await (await fetch(`${(R.root || '/').replace(/\/?$/, '/')}products/${encodeURIComponent(i.handle)}.js`)).json();
        fsCache[i.handle] = (p.tags || []).some((t) => String(t).trim().toLowerCase().replace(/\s+/g, '-') === 'final-sale');
      } catch (e) { fsCache[i.handle] = false; }
    }));
    return fsCache;
  }

  async function renderBag() {
    const body = $('bagBody'), foot = $('bagFoot'); if (!body) return;
    if (foot && !foot.dataset.codeWired) { foot.dataset.codeWired = '1'; wireCode(foot, renderBag); }
    const cart = await getCart(); setCount(cart.item_count);
    if (!cart.item_count) {
      body.innerHTML = `<div class="drawer-empty"><p class="h3" style="font-style:italic">${esc(tr('bag_empty', 'Your bag is empty.'))}</p><a class="btn ghost" href="${esc(R.root || '/')}collections/all-rugs">${esc(tr('explore', 'Explore the collection'))}</a></div>`;
      foot.innerHTML = ''; codeMsg = ''; codeOpen = false; return;
    }
    // Each rug lists only its own discounts (the sale). Order discounts (the automatic extra 5%, or an order code) are
    // listed once in the totals, the way checkout shows them (Waise, board q-bag-totals A, 2026-10-07).
    const fs = await finalSale(cart.items);
    const orderDisc = (cart.cart_level_discount_applications || []).filter((d) => d.total_allocated_amount > 0);
    body.innerHTML = cart.items.map((i, n) => `<div class="line-item">
        <a href="${esc(i.url)}">${i.image ? `<img src="${esc(src(i.image, 300))}" alt="" loading="lazy">` : ''}</a>
        <div><div class="n">${esc(i.product_title)}</div><div class="s">${esc(i.variant_title || '')}</div>${fs[i.handle] ? `<div class="s" style="color:var(--clay)">${esc(/['′]| ft|round/i.test(i.variant_title || '') && !/rug-pad|rug pad/i.test((i.handle || '') + ' ' + (i.product_type || '')) ? tr('final_sale_rug', "This rug is final sale and can't be returned or exchanged.") : tr('final_sale_item', "This item is final sale and can't be returned or exchanged."))}</div>` : ''}${Object.entries(i.properties || {}).filter(([k, v]) => v && k[0] !== '_').map(([k, v]) => `<div class="s" style="color:var(--clay)">${esc(k)}: ${esc(v)}</div>`).join('')}
          ${(i.line_level_discount_allocations || []).filter((d) => d.amount > 0).map((d) => `<div class="s" style="color:var(--clay)">${esc((d.discount_application && d.discount_application.title) || tr('discount', 'Discount'))} (−${money(d.amount, cart.currency)})</div>`).join('')}
          <div class="qty"><button data-q="${i.quantity - 1}" data-k="${esc(i.key)}" aria-label="${esc(tr('decrease', 'Decrease'))}">−</button><span class="num">${i.quantity}</span><button data-q="${i.quantity + 1}" data-k="${esc(i.key)}" aria-label="${esc(tr('increase', 'Increase'))}">+</button></div></div>
        <div class="r">${i.original_line_price > i.final_line_price ? `<s class="num" style="display:block;color:var(--ink-3);font-size:.85em">${money(i.original_line_price, cart.currency)}</s>` : ''}<span class="num">${money(i.final_line_price, cart.currency)}</span><button class="rm" data-q="0" data-k="${esc(i.key)}">${esc(tr('remove', 'Remove'))}</button></div>
      </div>`).join('');
    // Totals in checkout's order: Subtotal (after the rugs' own discounts), each order discount, Total before tax.
    // With no order discount only the total shows (it equals the subtotal).
    const totRow = (label, value, style) => `<div class="tot"${style ? ` style="${style}"` : ''}><span class="eyebrow">${esc(label)}</span><span class="num">${value}</span></div>`;
    foot.innerHTML = `${codeBoxHTML(cart)}${orderDisc.length ? totRow(tr('subtotal', FR ? 'Sous-total' : 'Subtotal'), money(cart.items_subtotal_price, cart.currency)) + orderDisc.map((d) => totRow(d.title || tr('discount', 'Discount'), `−${money(d.total_allocated_amount, cart.currency)}`, 'color:var(--clay)')).join('') : ''}<div class="tot"><span class="eyebrow">${esc(tr('total_before_tax', FR ? 'Total avant taxes' : 'Total before tax'))}</span><span class="tot-v"><b class="num">${money(cart.total_price, cart.currency)}</b></span></div>
      <small>${esc(tr('taxes_note', 'Shipping and taxes calculated at checkout.'))}</small>
      <a class="btn block" href="/checkout">${esc(tr('checkout', 'Checkout'))}</a>`;
    body.insertAdjacentHTML('beforeend', padBlockHTML(cart));
    body.onclick = async (e) => {
      const pb = e.target.closest('[data-pad-add]');
      if (pb) { pb.disabled = true; pb.textContent = tr('pad_added', 'Added'); await addPad(pb.dataset.padAdd, pb.dataset.padQty); renderBag(); return; }
      const b = e.target.closest('[data-k]'); if (b) change(b.dataset.k, Number(b.dataset.q));
    };
  }

  // ---------- predictive search ----------
  let st;
  async function runSearch() {
    const q = $('q'), res = $('qRes'); if (!q || !res) return;
    const t = q.value.trim();
    if (!t) { res.innerHTML = ''; return; }
    try {
      const url = `${R.suggest}?q=${encodeURIComponent(t)}&resources[type]=product&resources[limit]=12&resources[options][unavailable_products]=show`;
      const r = await fetch(url, { headers: { Accept: 'application/json' } });
      const j = await r.json();
      const raw = (j.resources && j.resources.results && j.resources.results.products) || [];
      // Exact rug name matches first (even when sold out), then in stock rugs, then other sold out rugs.
      const qw = t.toLowerCase().split(/\s+/)[0];
      const named = (p) => p.title.split(' ')[0].toLowerCase().startsWith(qw);
      const rank = (p) => (named(p) ? 0 : p.available ? 1 : 2);
      const ps = raw.map((p, i) => [p, i]).sort((a, b) => rank(a[0]) - rank(b[0]) || a[1] - b[1]).map((x) => x[0]);
      const nameOf = (title) => title.split(' ')[0];
      const subOf = (title) => title.split(' ').slice(1).join(' ').replace(/ Indoor Rug$| Rug$/, '');
      res.innerHTML = ps.length
        ? ps.map((p) => `<a class="card search-card in" href="${esc(p.url)}">
            <div class="card-media">${p.image ? `<img class="a" src="${esc(src(p.image, 400))}" alt="${esc(p.title)}" loading="lazy">` : ''}</div>
            <div class="card-info"><div class="card-name">${esc(nameOf(p.title))}</div><div class="card-price num">${p.price_min ? esc(money(Math.round(Number(p.price_min) * 100))) + (p.price_max && Number(p.price_max) > Number(p.price_min) ? ' – ' + esc(money(Math.round(Number(p.price_max) * 100))) : '') : ''}</div>
            <div class="card-sub" style="grid-column:1/-1">${esc(subOf(p.title))}${p.available ? '' : ' · ' + esc(tr('sold_out', 'Sold out'))}</div></div></a>`).join('')
          + `<p class="search-hint" style="grid-column:1/-1"><a class="link" href="${esc(R.search)}?q=${encodeURIComponent(t)}&type=product">${esc(tr('see_all_results', 'See all results'))}</a></p>`
        : `<p class="search-hint" style="grid-column:1/-1">${esc(tr('no_search_match', 'Nothing matches “{q}”.')).replace('{q}', esc(t))}</p>`;
    } catch (e) { res.innerHTML = ''; }
  }

  // ---------- toast ----------
  let tt;
  function toast(msg) { const t = $('toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('on'), 2800); }

  // ---------- lightbox ----------
  const lb = {
    list: [], i: 0,
    open(list, i) {
      this.list = list; this.i = i; const el = $('lightbox');
      el.classList.add('open'); el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; this.show();
      el.onclick = (e) => { const b = e.target.closest('[data-lb]'); if (b) { if (b.dataset.lb === 'close') this.close(); else this.step(+b.dataset.lb); } else if (e.target === el) this.close(); };
      this.keys = (e) => { if (e.key === 'ArrowRight') this.step(1); if (e.key === 'ArrowLeft') this.step(-1); };
      document.addEventListener('keydown', this.keys);
    },
    step(d) { this.i = (this.i + d + this.list.length) % this.list.length; this.show(); },
    show() { const el = $('lightbox'); el.querySelector('img').src = src(this.list[this.i], 2000); el.querySelector('.lb-count').textContent = `${this.i + 1} / ${this.list.length}`; },
    close() { const el = $('lightbox'); if (!el || !el.classList.contains('open')) return; el.classList.remove('open'); el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; document.removeEventListener('keydown', this.keys); },
  };

  // ---------- reveal on scroll ----------
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { rootMargin: '0px 0px -8% 0px' })
    : null;
  function reveal(root = document) {
    const run = () => root.querySelectorAll('.reveal:not(.in)').forEach((n) => (io ? io.observe(n) : n.classList.add('in')));
    if (document.documentElement.classList.contains('hold')) {
      let done = false; const go = () => { if (!done) { done = true; run(); } };
      document.addEventListener('rb:ready', go, { once: true }); setTimeout(() => (document.querySelector('.loader') ? setTimeout(go, 9000) : go()), 5000);
    } else run();
  }

  // ---------- drag to scroll (gallery wall) ----------
  function dragScroll(el, onMove) {
    let down = false, sx = 0, sl = 0, moved = false;
    el.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = el.scrollLeft; });
    window.addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 4) { moved = true; el.classList.add('dragging'); } el.scrollLeft = sl - dx; });
    window.addEventListener('pointerup', () => { down = false; setTimeout(() => el.classList.remove('dragging'), 0); });
    el.addEventListener('click', (e) => { if (moved) { e.preventDefault(); moved = false; } }, true);
    el.addEventListener('scroll', () => onMove && onMove(), { passive: true });
  }

  // ---------- page wiring ----------
  function init() {
    const header = $('header');
    if (header) { const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 10); window.addEventListener('scroll', onScroll, { passive: true }); onScroll(); }

    document.addEventListener('click', (e) => {
      const o = e.target.closest('[data-open]'); if (o) { e.preventDefault(); open(o.dataset.open); return; }
      if (e.target.closest('[data-close]') || e.target === $('scrim')) close();
      const ask = e.target.closest('[data-chatty]');
      if (ask) { const bar = document.querySelector('.chatty-ai-mode .aimode-sbar-container'); if (bar) { e.preventDefault(); bar.click(); return; } }
      const w = e.target.closest('[data-wish]');
      if (w) { e.preventDefault(); e.stopPropagation(); wishToggle(w); return; }
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { close(); lb.close(); } });

    // hover photos: loaded only for a real mouse, on first hover, plus the cards in view once the page is idle
    const wake = (img) => {
      if (!img.dataset.src) return;
      img.addEventListener('load', () => img.classList.add('ready'), { once: true });
      if (img.dataset.srcset) { img.srcset = img.dataset.srcset; img.removeAttribute('data-srcset'); }
      img.src = img.dataset.src; img.removeAttribute('data-src');
    };
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('pointerover', (e) => { const c = e.target.closest && e.target.closest('.card'); if (c) c.querySelectorAll('img[data-src]').forEach(wake); }, { passive: true });
      const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
      window.addEventListener('load', () => idle(() => document.querySelectorAll('.card img[data-src]').forEach((i) => { const r = i.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) wake(i); })), { once: true });
    }
    window.RBWake = wake;

    // hearts: paint now, on cards added later (load more, recently viewed) and when another tab changes the list
    wishPaint();
    let wt; new MutationObserver(() => { clearTimeout(wt); wt = setTimeout(() => wishPaint(), 60); }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', (e) => { if (e.key === WKEY) wishPaint(); });
    if (location.hash === '#saved') open('wish');
    // No full cart page (Waise, board q-final-sale-preview): /cart sends shoppers back with #bag, which opens the side cart.
    if (location.hash === '#bag') { open('bag'); history.replaceState(null, '', location.pathname + location.search); }
    // Remember the last real page in this tab, so /cart can send the shopper back to it (an app redirect on /cart drops the referrer).
    try { if (!/\/(cart|checkouts?|account)(\/|$)/.test(location.pathname)) { sessionStorage.setItem('rbLastPage', location.pathname + location.search); document.cookie = 'rbLastPage=' + encodeURIComponent(location.pathname + location.search) + '; path=/; max-age=7200; SameSite=Lax'; } } catch (e) {}

    // Chatty's assistant opens from the floating "Chat with us" button; its own bar only shows while the chat is open
    let chattyTries = 0;
    const chattyName = () => {
      const root = document.querySelector('.chatty-ai-mode');
      if (!root) { if (++chattyTries < 30) setTimeout(chattyName, 1000); return; }
      document.documentElement.classList.add('has-chatty');
      // hide our floating "Chat with us" button while the chat itself is open
      const sync = () => document.documentElement.classList.toggle('chatty-open', !root.classList.contains('state-resting'));
      new MutationObserver(sync).observe(root, { attributes: true, attributeFilter: ['class'] }); sync();
      // the header label stays "Ask AI" (rb.ask); the assistant introduces itself by name inside the chat
    };
    chattyName();

    const q = $('q');
    if (q) {
      q.addEventListener('input', () => { clearTimeout(st); st = setTimeout(runSearch, 180); });
      q.addEventListener('keydown', (e) => { if (e.key === 'Enter' && q.value.trim()) location.href = `${R.search}?q=${encodeURIComponent(q.value.trim())}&type=product`; });
      const hint = $('qHint'); if (hint) hint.addEventListener('click', (e) => { const b = e.target.closest('[data-q]'); if (b) { q.value = b.dataset.q; runSearch(); } });
    }

    // gallery walls
    document.querySelectorAll('[data-wall]').forEach((wall) => {
      const bar = wall.parentElement.querySelector('[data-wall-bar]');
      const prog = () => { if (!bar) return; const m = wall.scrollWidth - wall.clientWidth; bar.style.width = (20 + 80 * (m ? wall.scrollLeft / m : 0)) + '%'; };
      dragScroll(wall, prog); prog();
    });

    // review rotators
    document.querySelectorAll('[data-rotator]').forEach((rot) => {
      const qs = [...rot.querySelectorAll('.quote')], ds = [...rot.querySelectorAll('.dots button')];
      if (qs.length < 2) return;
      let qi = 0, timer;
      const show = (i) => { qi = i; qs.forEach((x, k) => x.classList.toggle('on', k === i)); ds.forEach((d, k) => d.classList.toggle('on', k === i)); };
      const auto = () => { clearInterval(timer); timer = setInterval(() => show((qi + 1) % qs.length), 6000); };
      ds.forEach((d, k) => d.addEventListener('click', () => { show(k); auto(); })); auto();
    });

    // cart page: − / + update the bag straight away
    const cartForm = document.getElementById('RBCart');
    if (cartForm) cartForm.addEventListener('click', (e) => {
      const b = e.target.closest('[data-step]'); if (!b) return;
      const inp = b.parentElement.querySelector('input'); inp.value = Math.max(0, (+inp.value || 0) + +b.dataset.step);
      const up = cartForm.querySelector('[name="update"]'); if (cartForm.requestSubmit) cartForm.requestSubmit(up); else up.click();
    });

    const cartCode = document.getElementById('rbCartCode');
    if (cartCode) {
      const paint = async (keep) => { if (keep === true) { cartCode.innerHTML = codeBoxHTML(await getCart(), 'rbCartCodeIn'); return; } if (codeMsg) { cartCode.innerHTML = codeBoxHTML(await getCart(), 'rbCartCodeIn'); return; } location.reload(); };
      getCart().then((cart) => { cartCode.innerHTML = codeBoxHTML(cart, 'rbCartCodeIn'); });
      wireCode(cartCode, paint);
    }
    const cartPad = document.getElementById('rbCartPad');
    if (cartPad) getCart().then((cart) => {
      cartPad.innerHTML = padBlockHTML(cart);
      cartPad.onclick = async (e) => { const pb = e.target.closest('[data-pad-add]'); if (!pb) return; pb.disabled = true; await addPad(pb.dataset.padAdd, pb.dataset.padQty); location.reload(); };
    });

    reveal();
  }

  // French pages: prices that Liquid wrote in the store format ($1,234.56) are shown the French way (1 234,56 $).
  if (FR) {
    const RX = /\$(\d{1,3}(?:,\d{3})*)\.(\d{2})(?!\d)/g;
    const conv = (root) => {
      const w = document.createTreeWalker(root || document.body, NodeFilter.SHOW_TEXT, { acceptNode: (n) => (n.nodeValue.indexOf('$') > -1 && !(n.parentNode && /^(SCRIPT|STYLE|TEXTAREA|INPUT)$/.test(n.parentNode.nodeName)) ? 1 : 2) });
      const list = []; while (w.nextNode()) list.push(w.currentNode);
      list.forEach((n) => { const v = n.nodeValue.replace(RX, (m, i, c) => i.replace(/,/g, '\u00a0') + ',' + c + '\u00a0$'); if (v !== n.nodeValue) n.nodeValue = v; });
    };
    let q = false;
    const run = () => { q = false; conv(); };
    const soon = () => { if (q) return; q = true; setTimeout(run, 30); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { conv(); new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, characterData: true }); });
    else { conv(); new MutationObserver(soon).observe(document.body, { childList: true, subtree: true, characterData: true }); }
  }

  window.RBUI = { LOGO, src, esc, money, open, close, addToBag, renderBag, getCart, toast, lb, reveal, dragScroll, icon, dims, fmtFt, bestPad, wishGet, wishPaint };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
